import { useCallback } from 'react';
import { noop } from 'underscore';
import usePreviousRef from 'hooks/usePreviousRef';
import {
  OnStateChange,
  TemplateAction,
  TemplateDispatch,
} from './action-types';
import reducer from './reducer';

type UseTemplateDispatchProps = {
  onChange?: OnStateChange;
};

/*
 * returns a dispatch function that sends actions to modify the editor's state.
 * the dispatch function reference will change when state changes - it's not
 * static.
 */
export default function useTemplateDispatch({
  onChange = noop,
}: UseTemplateDispatchProps): TemplateDispatch {
  const onChangeRef = usePreviousRef(onChange);

  const dispatch = useCallback(
    (action: TemplateAction) => {
      onChangeRef.current(prevState => reducer(prevState, action), action);
    },
    [onChangeRef],
  );

  return dispatch;
}
